export default function Logo() {
    return <div id="logo">
        <img id="mk8dx-logo" src={require("../assets/logos/Mario_Kart_8_Deluxe_logo.webp")} alt="Mario Kart 8 Deluxe Logo" />
        <p>Cup Builder</p>
    </div>
}